import React, { useState, useEffect } from 'react';
import { Layout, Menu, Row, Col } from 'antd';
import { GlobalOutlined, PhoneOutlined, HomeOutlined, MailOutlined } from '@ant-design/icons';
import Burger from '@animated-burgers/burger-slip';
import '@animated-burgers/burger-slip/dist/styles.css';
import classNames from 'classnames';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  Redirect
} from "react-router-dom";

import Analytics from './common/Analytics';
import Cluar from './common/Cluar';
import Builder from './common/Builder';
import Cookies from './components/Cookies';
import NotFound from './pages/NotFound';
import Dictionary from './components/Dictionary'
import Newsletter from './components/functionality/Newsletter';
import ContactMaps from './components/functionality/Footer';

import FtcLogo from './assets/images/FCTh.png';
import IstLogo from './assets/images/IST.png';
import CerisLogo from './assets/images/Ceris.png';


import './styles/App.less';
import './styles/index.less';

const { Header, Content, Footer } = Layout;
const { SubMenu } = Menu;

export default () => {

  let urlLang = null;
  if (urlLang = /^\/([a-z]+)\//ig.exec(window.location.pathname)) {
    Cluar.changeLanguage(urlLang[1]);
  } else {
    const storageLocale = window.localStorage.getItem('locale');
    if (storageLocale == null) {
      Cluar.changeLanguage(Cluar.defaultLanguage().locale);
    } else {
      Cluar.changeLanguage(storageLocale);
    }
  }

  const [burgerMenu, setBurgerMenu] = useState(false);
  const [activeMenu, setActiveMenu] = useState('main');
  const [locale, setLocale] = useState(Cluar.currentLanguage().locale);

  const handleMenuClick = (selectMenu) => {
    setBurgerMenu(false);
    if (selectMenu) {
      setActiveMenu(selectMenu);
    }
    window.scrollTo(0, 0);
  };

  const menuLanguages = [];
  const menu = [];
  const subMenuKeys = [];
  const routes = [];
  for (const language of Cluar.languages()) {
    if (!Cluar.pages()[language.code]) {
      continue;
    }
    if (language.code !== Cluar.currentLanguage().code) {
      menuLanguages.push(
        <Menu.Item key={language.code} onClick={() => {
          Cluar.changeLanguage(language.locale);
          window.localStorage.setItem('locale', Cluar.currentLanguage().locale);
          window.location.href = `/${language.locale}/`;
        }}>{language.description}</Menu.Item>
      );
    }

    const buildMenu = (page, level) => {
      if (page.menu && language.code === Cluar.currentLanguage().code) {
        const key = `${page.link}`;
        if (Cluar.pages()[language.code].find((p) => p.menu && p.parent === page.link)) {
          subMenuKeys.push(key);
          return (
            <SubMenu key={key} popupClassName={`header-submenu ${level + 1}`} title={
              page.navigable ?
                (page.link.indexOf('//') >= 0 ?
                  <a href={`${page.link}`} target="_blank">
                    {page.title}
                  </a>
                  : <Link to={`/${Cluar.currentLanguage().locale}${page.link}`} onClick={() => handleMenuClick(key)}>
                    {page.title}
                  </Link>)
                : <a>{page.title}</a>
            }>
              {Cluar.pages()[language.code].filter((p) => p.menu && p.parent === page.link).map((p) => buildMenu(p, level + 1))}
            </SubMenu>
          );
        } else {
          if (level == 1) {
            return (
              <Menu.Item key={key}>
                {page.navigable ?
                  (page.link.indexOf('//') >= 0 ?
                    <a href={`${page.link}`} target="_blank">
                      <p>{page.title}</p>
                      <p>{page.description}</p>
                    </a>
                    : <Link to={`/${Cluar.currentLanguage().locale}${page.link}`} onClick={() => handleMenuClick(key)}>
                      <p>{page.title}</p>
                    </Link>)
                  : <a>
                    <p className="sub-menu-item-title">{page.title}</p>
                    <p className="sub-menu-item-description">{page.description}</p>
                  </a>}
              </Menu.Item>
            );
          }

          return (
            <Menu.Item key={key}>
              {page.navigable ?
                (page.link.indexOf('//') >= 0 ?
                  <a href={`${page.link}`} target="_blank">{page.title}</a>
                  : <Link to={`/${Cluar.currentLanguage().locale}${page.link}`} onClick={() => handleMenuClick(key)}>
                    {page.title}
                  </Link>)
                : <a>{page.title}</a>}
            </Menu.Item>
          );
        }
      }
      return null;
    };

    const subroutes = [];

    for (const page of Cluar.pages()[language.code]) {
      if (page.menu && page.parent === "" && language.code === Cluar.currentLanguage().code) {
        menu.push(
          buildMenu(page, 0)
        );
      }

      if (page.navigable == false || page.link.indexOf('//') >= 0) {
        continue;
      }

      subroutes.push(
        <Route key={`/${language.locale}${page.link}`} exact path={`/${language.locale}${page.link}`} exact render={(propRouter) => {
          return <Builder page={page} />;
        }} />
      );

    }

    routes.push(
      <Route key={`/${language.locale}/`} path={`/${language.locale}/`}>
        {subroutes}
      </Route>
    );

  }

  useEffect(() => {
  }, []);


  return (
    <Router>
      {Analytics.init() && <Analytics.RouteTracker />}
      <div className="page">

        <Layout>
          <Header className={classNames({ 'header-burger-open': burgerMenu })}>
            <div className="site-header-inner container">
              <div className="logo">
                <Link to={`/${Cluar.currentLanguage().locale}/`} onClick={() => handleMenuClick('/')}>
                  <img alt="logo" src="/images/logo.png" />
                </Link>
              </div>
              <div className={
                classNames({
                  'menu': true
                })
              }>
                <Menu
                  theme="light"
                  mode="horizontal"
                  defaultSelectedKeys={[activeMenu]}
                  selectedKeys={[activeMenu]}>
                  {menu}
                </Menu>
              </div>
              <div className={
                classNames({
                  'menu': true,
                  'menu-burger': true,
                  'menu-burger-open': burgerMenu
                })
              }>
                <Menu
                  mode="inline"
                  defaultSelectedKeys={[activeMenu]}
                  selectedKeys={[activeMenu]}
                  openKeys={subMenuKeys}>
                  {menu}
                </Menu>
              </div>
              <div className="menu-burger-button">
                <Burger isOpen={burgerMenu} onClick={() => { setBurgerMenu(!burgerMenu); }} />
              </div>
              {/*
              <Menu
                theme="light"
                className="menu-languages"
                mode={'horizontal'}
                defaultSelectedKeys={[activeMenu]}
                selectedKeys={[activeMenu]}>
                <SubMenu key="langs" icon={<GlobalOutlined />} title={Cluar.currentLanguage().code}>
                  {menuLanguages}
                </SubMenu>
              </Menu>
              */}
            </div>
          </Header>
          <Content>
            <Switch>
              <Route path="/" exact render={(propRouter) => {
                return <Redirect to={`/${Cluar.currentLanguage().locale}/`} />;
              }} />
              {routes}
              <Route component={NotFound} />
            </Switch>
          </Content>
          <Footer>
            <div className="container">
              <Row justify="center">
                <Col className='col-center'>
                  <p>
                    Copyright © &nbsp;
                    <a
                      href="positivecycle.pt/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      PositiveCycle
                    </a>
                    &nbsp; {new Date().getFullYear()}
                  </p>
                </Col>
              </Row>
            </div>
          </Footer>
          <Cookies />
        </Layout>
      </div>
    </Router>
  );
}
